// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import Close from "@synd/XDL/Icons/Close";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { xBaseTheme } from "@synd/XDL/types";
import { color, styledScrollbar, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 543,
        medium: 800,
        large: 1110,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
            `,
            modalTitle: css`
                position: relative;
                padding: 11px 16px;
                border-bottom: 0;
                background-color: ${color("common.ui8")};
            `,
            modalContent: css`
                padding: 16px;
                ${styledScrollbar({ width: 8, margined: 2 })}
            `,
            modalBody: css`
                border-radius: 8px;
                background-color: ${color("common.white")};
                border: 1px solid ${color("common.ui2")};
                box-shadow: unset;
                overflow: hidden;
                ${xScreen("lt", "md")} {
                    max-width: 90%;
                    height: auto;
                    max-height: calc(100% - 30px);
                    margin: 15px;
                }
            `,
        },
        headlineTypographyProps: {
            size: fontConfig.smallHeadLine.size,
            lineHeight: fontConfig.smallHeadLine.lineHeight,
            weight: fontConfig.weight.bold,
        },
        closeButtonProps: {
            mergeCss: true,
            variant: "link" as any,
            css: css`
                width: 12px;
                height: 16px;
                &&&& > ${IconWrapper} {
                    color: ${color("common.ui7")};
                }
                &&&&:not(:disabled):hover,
                &&&&:not(:disabled):focus {
                    > ${IconWrapper} {
                        color: ${color("common.ui10")};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            color: "common.ui7",
            width: 12,
            height: 16,
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
    },
} as xBaseTheme["modal"];
